// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchBoxComponent {
  height: 40px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  margin-left: 12px;
  display: flex;
  min-width: 304px;
}
.searchBoxComponent .textLabel {
  padding: 9px 12px;
  width: 80%;
  font-weight: 500;
  font-size: 16px;
  border: none;
  line-height: 22px;
  color: #868686;
  border-radius: 8px;
}
.searchBoxComponent .textLabel:focus-visible {
  outline: none;
}
.searchBoxComponent .searchIcon {
  width: 18px;
  height: 18px;
  margin-left: auto;
  margin-right: 12px;
  position: relative;
  top: 11px;
}`, "",{"version":3,"sources":["webpack://./src/screens/listOfEmployees/searchBox/SearchBox.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;AACJ;AACI;EACI,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AACR;AACI;EACI,aAAA;AACR;AACI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AACR","sourcesContent":[".searchBoxComponent {\n    height: 40px;\n    background: #ffffff;\n    border: 1px solid #e9e9e9;\n    border-radius: 8px;\n    margin-left: 12px;\n    display: flex;\n    min-width: 304px;\n\n    .textLabel {\n        padding: 9px 12px;\n        width: 80%;\n        font-weight: 500;\n        font-size: 16px;\n        border: none;\n        line-height: 22px;\n        color: #868686;\n        border-radius: 8px;\n    }\n    .textLabel:focus-visible{\n        outline: none;\n    }\n    .searchIcon {\n        width: 18px;\n        height: 18px;\n        margin-left: auto;\n        margin-right: 12px;\n        position: relative;\n        top: 11px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
